import React from "react";
import Skeleton from "../../Common/Skeleton";

const CDChartSkeleton = () => {
  return (
    <div className="flex flex-col space-y-2">
      <Skeleton className="rounded-3xl flex flex-col justify-between p-4 space-y-3">
        <Skeleton className="rounded-full w-40 h-5" />
        <div className="relative w-full h-[360px] flex items-center justify-center">
          <Skeleton className="rounded-xl w-full h-full" />
        </div>
        <Skeleton className="rounded-full w-full h-5" />
      </Skeleton>
    </div>
  );
};

export default CDChartSkeleton;
